<template>
  <div class="container mb-5">
    <div class="row mb-5 my-md-5">
      <div class="col-sm-6 offset-sm-3">
        <h1 class="text-center">
          {{ $t("rankingDeProdutos") }}
        </h1>
      </div>
    </div>
    <VisionFiveCharts />
  </div>
</template>

<script>
import VisionFiveCharts from './components/VisionFiveCharts.vue';

export default {
  components: { VisionFiveCharts },
};
</script>
